// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"f9614d94","73":"1aa8564c","137":"2baa2cb7","152":"ebf8ca26","523":"19e56da0","593":"898f2a0e","778":"8f43a747","833":"39388682","848":"ca0969a8","868":"007c6bd1"}[chunkId] + ".chunk.js";
};